"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addIndentationControls = addIndentationControls;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _toolbar = require("../constants/toolbar");

var _ControlButton = _interopRequireDefault(require("../components/toolbar/ControlButton"));

var _hsformatting = require("../constants/hsformatting");

var _i18n = require("../utils/i18n");

var i18nKey = (0, _i18n.i18nWithNameSpace)(_hsformatting.i18nNameSpace);

var getOutdentClickHandler = function getOutdentClickHandler(editor) {
  return function () {
    editor.execCommand('outdent');
  };
};

var getIndentClickHandler = function getIndentClickHandler(editor) {
  return function () {
    editor.execCommand('indent');
  };
};

var indentationControls = [{
  controlName: 'canvasoutdent',
  iconName: 'outdent',
  formatName: 'outdent',
  tooltip: 'tooltip.outdent',
  getClickHandler: getOutdentClickHandler
}, {
  controlName: 'canvasindent',
  iconName: 'indent',
  formatName: 'indent',
  tooltip: 'tooltip.indent',
  getClickHandler: getIndentClickHandler
}];

function addIndentationControls(editor) {
  indentationControls.forEach(function (_ref) {
    var controlName = _ref.controlName,
        iconName = _ref.iconName,
        formatName = _ref.formatName,
        tooltip = _ref.tooltip,
        getClickHandler = _ref.getClickHandler;
    editor.addButton(controlName, {
      type: _toolbar.CANVAS_BUTTON_TYPE,
      renderControl: function renderControl(props) {
        return _react.default.createElement(_ControlButton.default, (0, _extends2.default)({
          editor: editor,
          formatName: formatName,
          iconName: iconName,
          tooltip: i18nKey(tooltip),
          onClick: getClickHandler(editor)
        }, props));
      }
    });
  });
}